module.exports = __webpack_public_path__ + "media/images/3-01-ee0f9f2c6b3231845bea4f57fb65c16b.svg";